import { useEffect, useRef } from 'react';
import { AccommodationCombined } from '../Accommodations/Accommodation.types';
import { useAccommodationsHotelsCounts } from './useAccommodationsHotelsCounts';
import { useCustomPageTelemetry } from '@apps/guest/packages/layout-engine/widgets/Custom/Custom.telemetry';
import { PriceComparisonFragment, TravelPlacePricingAndBookingDetailsFragment } from '@graphql/generated';

interface AccommodationsHotelsCountProps {
  accommodations: AccommodationCombined[];
  priceDataList: TravelPlacePricingAndBookingDetailsFragment[];
  travelPlaces: PriceComparisonFragment[];
}

export const AccommodationsHotelsCount = ({ accommodations, priceDataList, travelPlaces }: AccommodationsHotelsCountProps) => {
  const isTelemetryCalledRef = useRef<boolean>(false);

  const telemetry = useCustomPageTelemetry();

  const { accommodationsHotelsCounts, accommodationsHotelsCountsLoading } = useAccommodationsHotelsCounts(accommodations, priceDataList, travelPlaces);

  useEffect(() => {
    if (accommodationsHotelsCountsLoading || isTelemetryCalledRef.current) return;
    telemetry.guestAccommodationsData('accommodations', accommodationsHotelsCounts);
    isTelemetryCalledRef.current = true;
  }, [accommodationsHotelsCounts, accommodationsHotelsCountsLoading, telemetry]);

  return null;
};
